import { WidgetColumn } from "@bryntum/grid-thin";

export class TicketDialogColumn extends WidgetColumn {
  static get type() {
    return "ticketDialog";
  }

  // @ts-ignore - Bryntum 7.x declares widgets as a property, but we need to override as accessor
  override get widgets() {
    return [
      {
        type: "button",
        icon: "b-fa b-fa-external-link-alt",
        tooltip: "Pop-up",
        color: "blue",
        cls: "b-raised",
        onAction: ({ source: btn }) => {
          console.log("default ticket dialog widget firing");
          // @ts-ignore
          this.grid.trigger("ticketDialog", {
            type: "ticketDialog",
            record: btn.cellInfo.record
          });
        }
      }
    ];
  }
}
